(() => {
  function init(section) {
    if (section.dataset.stackFilmReady) return;

    const video = section.querySelector('video');
    const soundButton = section.querySelector('[data-stack-film-sound]');
    const soundLabel = section.querySelector('[data-stack-film-sound-label]');
    if (!video || !soundButton || !soundLabel) return;
    section.dataset.stackFilmReady = 'true';

    const updateSound = () => {
      const label = video.muted ? soundButton.dataset.unmuteLabel : soundButton.dataset.muteLabel;
      soundButton.setAttribute('aria-label', label);
      soundLabel.textContent = label;
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.autoplay = false;
      video.pause();
      video.controls = true;
      soundButton.hidden = true;
      return;
    }

    video.muted = true;
    updateSound();
    soundButton.addEventListener('click', () => {
      video.muted = !video.muted;
      video.play().catch(() => {});
      updateSound();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.muted = true;
          updateSound();
        }
      }, { threshold: 0.1 }).observe(section);
    }
  }

  document.querySelectorAll('[data-stack-film]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-stack-film]').forEach(init);
  });
})();
